import { render, staticRenderFns } from "./ImageBank.vue?vue&type=template&id=e0b94032&scoped=true&"
import script from "./ImageBank.vue?vue&type=script&lang=js&"
export * from "./ImageBank.vue?vue&type=script&lang=js&"
import style0 from "./ImageBank.vue?vue&type=style&index=0&id=e0b94032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b94032",
  null
  
)

export default component.exports